// @ts-nocheck
import React from "react";
import { tableProps } from "@store/Themes/common/props/table";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DataTableBody, DataTableCell, DataTableRow } from "@insite/mobius/index";
import { ProductUnitConversions } from "@store/Framework/Types/ApiModels";

interface UnitOfMesasureConversionTableProps {
    unitConversionTable: string;
}

export interface UnitOfMesasureConversionTableStyles {
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
}

export const unitOfMesasureConversionTableStyles: UnitOfMesasureConversionTableStyles = {
    tableWrapper: tableProps.wrapper,
    dataTable: tableProps.dataTable,
};

const styles = unitOfMesasureConversionTableStyles;

const UnitOfMesasureConversionTable = ({ unitConversionTable }: UnitOfMesasureConversionTableProps) => {
    const unitConversions = JSON.parse(unitConversionTable) as ProductUnitConversions[];

    return (
        <StyledWrapper {...styles.tableWrapper}>
            <DataTable {...styles.dataTable}>
                <DataTableBody>
                    {unitConversions.map(unitConversion => (
                        <DataTableRow key={unitConversion.unitDisplay}>
                            <DataTableCell>{unitConversion.unitDisplay}</DataTableCell>
                            <DataTableCell>{unitConversion.qtyDisplay}</DataTableCell>
                        </DataTableRow>
                    ))}
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

export default UnitOfMesasureConversionTable;
